var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3668 0H10.914V13.6232C10.914 15.2464 9.58602 16.5797 7.9334 16.5797C6.28077 16.5797 4.95278 15.2464 4.95278 13.6232C4.95278 12.029 6.25127 10.7246 7.84488 10.6667V7.24639C4.33305 7.30433 1.5 10.1159 1.5 13.6232C1.5 17.1594 4.39207 20 7.96292 20C11.5337 20 14.4258 17.1304 14.4258 13.6232V6.63767C15.7243 7.56522 17.3179 8.11594 19 8.14494V4.72464C16.4031 4.63768 14.3668 2.55072 14.3668 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.da2d589934c4ee230e12f8e011a4eb62.svg";
export { ForwardRef as ReactComponent };